module.exports = __webpack_public_path__ + "img/sg.670ec478.png";